module.exports = __webpack_public_path__ + "static/media/jingteshu21.0d3c741b.png";